/**
 * タググループ関連のユーティリティ
 * style / mood / other のグループ定義・ラベル変換・カラー取得を一元管理する
 */

export const TAG_GROUPS = [
  { key: 'style', label: 'style', prefix: 'style.' },
  { key: 'mood', label: 'mood', prefix: 'mood.' },
  { key: 'other', label: 'other', prefix: '' },
] as const;

export type TagGroupKey = (typeof TAG_GROUPS)[number]['key'];

/** タグ名からグループキーを取得 */
export const getTagGroup = (name: string): TagGroupKey => {
  if (name.startsWith('style.')) return 'style';
  if (name.startsWith('mood.')) return 'mood';
  return 'other';
};

/** タグ名のプレフィックス（style. / mood.）を除いた表示ラベルを返す */
export const getTagLabel = (name: string): string =>
  name.replace(/^style\./, '').replace(/^mood\./, '');

/**
 * タグバッジ表示用クラス（インライン badge）
 *   style → パステルブルー
 *   mood  → パステルピンク
 *   other → 薄グレー
 */
export const getTagColorClass = (name: string): string => {
  const group = getTagGroup(name);
  if (group === 'style') return 'bg-blue-100 text-blue-700 border-blue-200';
  if (group === 'mood')  return 'bg-pink-100 text-pink-700 border-pink-200';
  return 'bg-gray-100 text-gray-600 border-gray-200';
};

/**
 * フィルターボタン用クラス（active 時は1段階濃い色）
 */
export const getTagFilterClass = (name: string, active: boolean): string => {
  const group = getTagGroup(name);
  if (active) {
    if (group === 'style') return 'bg-blue-200 border-blue-400 text-blue-800';
    if (group === 'mood')  return 'bg-pink-200 border-pink-400 text-pink-800';
    return 'bg-gray-200 border-gray-400 text-gray-800';
  }
  return getTagColorClass(name);
};
